import React, { useEffect } from 'react'
import { Typography, theme, Space } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons'

const { Text, Title } = Typography

const GenAIGenerating = () => {
  const { token } = theme.useToken()

  // Inject CSS animations
  useEffect(() => {
    const styleId = 'genai-generating-animations'
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style')
      style.id = styleId
      style.textContent = `
        @keyframes genai-pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.8;
          }
          50% {
            transform: scale(1.05);
            opacity: 1;
          }
        }

        .genai-pulse-animation {
          animation: genai-pulse 2s infinite ease-in-out;
        }
      `
      document.head.appendChild(style)
    }
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '350px',
        padding: '32px',
        backgroundColor: '#fafafa',
        textAlign: 'center'
      }}
    >
      <Space direction='vertical' size={20} style={{ alignItems: 'center' }}>
        {/* Subtle Animated Icon */}
        <div
          className='genai-pulse-animation'
          style={{
            fontSize: '40px',
            color: token.colorPrimary,
            marginBottom: '8px'
          }}
        >
          <FontAwesomeIcon icon={faWandMagicSparkles} />
        </div>

        {/* Title */}
        <Title
          level={4}
          style={{
            margin: 0,
            color: token.colorText,
            fontWeight: '500'
          }}
        >
          AI is generating your content
        </Title>

        {/* Description */}
        <Text
          style={{
            fontSize: '14px',
            color: token.colorTextSecondary,
            maxWidth: '300px',
            lineHeight: '1.5'
          }}
        >
          Please wait while our AI processes your request and generates the content.
        </Text>
      </Space>
    </div>
  )
}

export default GenAIGenerating
